import { pathOr } from 'ramda'

import { useAppSelector } from '../store/hooks'

const useDiagnosis = () => {
  const diagnosisTest = useAppSelector((state) => pathOr(false, ['client', 'diagnosisTest'], state))

  return { diagnosisTest }
}

export default useDiagnosis
